import {ValueObject} from '@s-ui/domain'

export class SaveInstantOfferDraftFromAPISellerRequest extends ValueObject {
  static create({
    makeId,
    makeName,
    modelId,
    modelName,
    versionId,
    versionName,
    fuelId,
    year,
    km,
    transmissionTypeId,
    bodyTypeDoors,
    plate,
    vehicleStatus
  }) {
    return new SaveInstantOfferDraftFromAPISellerRequest({
      makeId: makeId ? Number(makeId) : null,
      makeName: makeName || null,
      modelId: modelId ? Number(modelId) : null,
      modelName: modelName || null,
      versionId: versionId ? Number(versionId) : null,
      versionName: versionName || null,
      fuelId: fuelId ? Number(fuelId) : null,
      year: year ? Number(year) : null,
      mileage: km ? Number(km) : null,
      transmissionTypeId: transmissionTypeId ? Number(transmissionTypeId) : null,
      bodyTypeDoors: bodyTypeDoors || null,
      condition: vehicleStatus || null,
      licensePlate: plate || null
    })
  }

  toJSON() {
    return {
      makeId: this._makeId,
      makeName: this._makeName,
      modelId: this._modelId,
      modelName: this._modelName,
      versionId: this._versionId,
      versionName: this._versionName,
      fuelId: this._fuelId,
      year: this._year,
      mileage: this._mileage,
      transmissionTypeId: this._transmissionTypeId,
      bodyTypeDoors: this._bodyTypeDoors,
      condition: this._condition,
      licensePlate: this._licensePlate
    }
  }
}

export const factory = SaveInstantOfferDraftFromAPISellerRequest.create
